/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { MmmModelOutput } from '../mmmModelOutput';
import { DataPointSetByString } from 'features/charts/chart.models';
import { sum } from '../charts/mmm-chart-helpers';

export const PRIOR_SPEND = 'Prior Spend';

export function createOptimisedSpendDataSets(
  mmmResponse: MmmModelOutput
): Map<string, DataPointSetByString[]> {
  const dataPointSets: Map<string, DataPointSetByString[]> = new Map<
    string,
    DataPointSetByString[]
  >();

  for (const forecast of mmmResponse.forecasts) {
    let dataPointSetByMetricTypeName = dataPointSets.get(
      forecast.sourceCategoryDisplayName
    );

    if (!dataPointSetByMetricTypeName) {
      dataPointSets.set(forecast.sourceCategoryDisplayName, []);
      dataPointSetByMetricTypeName = dataPointSets.get(
        forecast.sourceCategoryDisplayName
      );
    }

    for (
      let spendIterable = 0;
      spendIterable < forecast.maximumForecastSpend;
      spendIterable++
    ) {
      const spend = forecast.returnValues[spendIterable] ?? 0;

      const dataPointSet: DataPointSetByString = {
        dataPointString: forecast.sourceCategoryDisplayName,
        dataPointSetName: 'Optimised Spend',
        value: spend ? spend / 10000 : 0
      };

      dataPointSetByMetricTypeName!.push(dataPointSet);
    }
  }

  return dataPointSets;
}

export function createPriorSpendDataSets(
  mmmResponse: MmmModelOutput
): DataPointSetByString[] {
  const dataPointSets: DataPointSetByString[] = [];

  for (const forecast of mmmResponse.forecasts) {
    const allMarketingSourceChannelSpendsSummed = sum(
      mmmResponse.forecasts.map((forecast) => forecast.spend)
    );

    const priorSpend = forecast.spend / allMarketingSourceChannelSpendsSummed;

    const dataPointSet: DataPointSetByString = {
      dataPointString: forecast.sourceCategoryDisplayName,
      dataPointSetName: PRIOR_SPEND,
      value: priorSpend
    };

    dataPointSets.push(dataPointSet);
  }

  return dataPointSets;
}
